import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import type { ApprovalMode, ContractRiskLevel } from "@/domains/core"
import { erc20Abi } from "@/domains/abis"
import { determineApprovalAmount } from "@/domains/library"

import { simulatedTransaction } from "../simulated-transaction"

type ApproveStakePairAllowanceProps = {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address
  gaugeAddress: Address
  amount: bigint
  approvalMode: ApprovalMode
  contractRiskLevel: ContractRiskLevel
}

export const approveStakePairAllowance = async ({
  account,
  chainId,
  config,
  pairAddress,
  gaugeAddress,
  amount,
  approvalMode,
  contractRiskLevel,
}: ApproveStakePairAllowanceProps): Promise<TransactionReturnType> => {
  try {
    const actualAmountToApprove = determineApprovalAmount(amount, approvalMode, contractRiskLevel)

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: erc20Abi as Abi,
        account,
        address: pairAddress,
        args: [gaugeAddress, actualAmountToApprove],
        chainId,
        functionName: "approve",
      },
    })

    return result
  } catch (error: unknown) {
    console.error("approveStakePairAllowance", error)
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      code: error instanceof Error && "code" in error ? Number((error as { code: string }).code) : 0,
    }
  }
}
